import { Box, Image } from '@chakra-ui/react';
import { DeleteIcon } from '@halo/ui-chat-react';

type ImgUploadedPropsType = {
  imgUrl: string;
  onDel: () => void;
};

export function ImgUploaded({ imgUrl, onDel }: ImgUploadedPropsType) {
  return (
    <Box
      w="90px"
      h="90px"
      flex="none"
      borderRadius={'6px'}
      position="relative"
      overflow={'hidden'}
      cursor="pointer"
      css={{ '--maskZindex': '-1' }}
      _hover={{ '--maskZindex': '99' }}
    >
      <Box
        inset={'0'}
        position={'absolute'}
        color="white"
        display={'flex'}
        alignItems="center"
        justifyContent={'center'}
        backgroundColor="rgba(0, 0, 0, 0.7)"
        zIndex={'var(--maskZindex, -1)'}
      >
        <DeleteIcon style={{ width: 24, height: 24 }} onClick={onDel} />
      </Box>
      <Image w={'full'} h={'full'} backgroundColor="#EBEBEB" src={imgUrl} />;
    </Box>
  );
}
